// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3HYfS","left":"StickyBox_left__3h-A_","right":"StickyBox_right__nG3vi"};